import React from 'react'

export const Check = ({ size }) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3.5" strokeLinecap="round" strokeLinejoin="round" style={{ width: size, height: size }}>
        <polyline points="20 6 9 17 4 12" />
    </svg>
)

// Clickable pipeline stepper for one open opportunity. Mark as Sold / Mark Dead
// live in the page subheader, not here. `embedded` drops the outer box +
// "Deal Stage" heading so it can live inside another panel.
export const StageTracker = ({ opportunity, stages, onSetStage, embedded = false }) => {
    const currentIdx = stages.findIndex((s) => s.id === opportunity.stage)
    const current = stages[currentIdx]

    return (
        <div className={`stage-tracker${embedded ? ' embedded' : ''}`}>
            {!embedded && (
                <div className="stage-tracker-head">
                    <div className="stage-tracker-title">Deal Stage</div>
                    <div className="stage-tracker-sub">
                        {currentIdx >= 0 ? `Step ${currentIdx + 1} of ${stages.length} · ${current?.name || ''}` : ''}
                    </div>
                </div>
            )}
            <div className="stepper">
                {stages.map((s, i) => {
                    const cls = i < currentIdx ? 'done' : i === currentIdx ? 'current' : ''
                    return (
                        <React.Fragment key={s.id}>
                            {/* Connector trailing the previous stage; filled once that stage is reached. */}
                            {i > 0 && <div className={`step-conn${i - 1 <= currentIdx ? ' filled' : ''}`} />}
                            <div className={`step ${cls}`} onClick={() => onSetStage(opportunity.id, s.id)} title={`Move to ${s.name}`}>
                                <div className="step-label">{s.name}</div>
                            </div>
                        </React.Fragment>
                    )
                })}
            </div>
        </div>
    )
}
